import { useUser } from "@clerk/clerk-react";
import { useEffect, useRef } from "react";

import { identifyUser, resetUser } from "@/lib/analytics";

export default function AnalyticsIdentity() {
  const { user, isLoaded } = useUser();
  const lastIdentifiedUserId = useRef(null);

  useEffect(() => {
    if (!isLoaded) return;

    if (!user) {
      if (lastIdentifiedUserId.current) {
        lastIdentifiedUserId.current = null;
        resetUser();
      }
      return;
    }

    if (lastIdentifiedUserId.current === user.id) return;
    lastIdentifiedUserId.current = user.id;

    identifyUser(user.id, {
      email: user.primaryEmailAddress?.emailAddress,
      created_at: user.createdAt,
    });
  }, [isLoaded, user]);

  return null;
}
